<template>
  <div class="ma-3">
    <h1 style="font-size: xx-large;margin-top: 80px; line-height: 35px; font-weight: bold;"
      :style="{ color: $ajustes.colorTexto2 }">NOSOTROS</h1>
    <h1 style="font-size:large; line-height: 35px; font-weight: normal;" :style="{ color: $ajustes.colorTexto2 }">
      Donde nace tu vocación</h1>
    <v-row class="ma-2">
      <v-col class="ma-0 pa-2" lg="6" md="6" sm="6" cols="12" style="height: 100%;">
        <v-container>
          <h1 style="text-align: justify; line-height: 20px; font-size: 15pt;">MISIÓN</h1>
          <span class="mt-2" style="font-size: small;">{{ instituto.mision }}</span>
        </v-container>
      </v-col>
      <v-col class="ma-0 pa-2" lg="6" md="6" sm="6" cols="12" style="height: 100%;">
        <v-container>
          <h1 style="text-align: justify; line-height: 20px; font-size: 15pt;">VISIÓN</h1>
          <span class="mt-2" style="font-size: small;">{{ instituto.vision }}</span>
        </v-container>
      </v-col>
      <v-col class="ma-0 pa-2" lg="6" md="6" sm="6" cols="12" style="height: 100%;">
        <h1 style="text-align: justify; line-height: 20px; font-size: 15pt;">PRINCIPIOS</h1>
        <ul class="mt-2">
          <li v-for="(valor, index) in instituto.principios.split(',')" :key="index">
            <span class="mt-2" style="font-size: small;">
              {{ valor.trim().charAt(0).toUpperCase() + valor.trim().slice(1).toLowerCase() }}
            </span>
          </li>
        </ul>
      </v-col>
      <v-col lg="6" md="6" sm="6" cols="12">
        <h1 style="text-align: justify; line-height: 20px; font-size: 15pt;">VALORES</h1>
        <ul class="mt-2">
          <li v-for="(valor, index) in instituto.valores.split(',')" :key="index">
            <span class="mt-2" style="font-size: small;">
              {{ valor.trim().charAt(0).toUpperCase() + valor.trim().slice(1).toLowerCase() }}
            </span>
          </li>
        </ul>
      </v-col>
    </v-row>

    <v-row class="ma-2">
      <v-col v-if="fichas.length != 0" class="ma-0 pa-2" lg="12" md="12" sm="12" cols="12" style="height: 100%;">
        <h1 style="text-align: justify; line-height: 20px; font-size: 15pt;">INSTRUCTORES</h1>
      </v-col>
      <v-col class="ma-0 pa-2" lg="6" md="6" sm="6" cols="12" style="height: 100%;">
        <v-container class="pa-1" v-for="ficha in fichas" :key="ficha.id"
          style="align-items: center;align-items: center;">
          <ficha :propFicha="ficha" />
        </v-container>
      </v-col>
    </v-row>
    <v-row v-if="false" class="pt-2">
      <v-col class="ma-0 pa-2" lg="7" md="7" sm="7" cols="12" style="height: 100%;">
        <v-container class="pa-1" v-for="ficha in fichas" :key="ficha.id"
          style="align-items: center;align-items: center;">
          <ficha :propFicha="ficha" />
        </v-container>
        <v-container class="pt-5 pb-5">
          <h1 style="text-align: justify; line-height: 20px; font-size: 15pt;">HISTORIA</h1>
          <span class="mt-2" style="font-size: small; text-align: justify;">{{ instituto.historia }}</span>
        </v-container>
      </v-col>
      <v-col class="ma-0 pa-2" lg="5" md="5" sm="5" cols="12">
        <v-container class="pa-1" style="align-items: center;align-items: center; height: 100%;">
          <div style="width: 100%; height: 100%;">
            <v-card :style="{ backgroundColor: $ajustes.colorElemento }" elevation="1" class="line pa-3"
              :disabled="loading" :loading="loading" style="height: 100%;">
              <template v-slot:loader="{ isActive }">
                <v-progress-linear :active="isActive" color="deep-purple" height="4" indeterminate></v-progress-linear>
              </template>
              <br>
              <v-container>
                <h1 style="text-align: justify; line-height: 20px; font-size: 15pt;">MISIÓN</h1>
                <span class="mt-2" style="font-size: small;">{{ instituto.mision }}</span>
              </v-container>
              <br>
              <v-container>
                <h1 style="text-align: justify; line-height: 20px; font-size: 15pt;">VISIÓN</h1>
                <span class="mt-2" style="font-size: small;">{{ instituto.vision }}</span>
              </v-container>
              <br>
              <v-container>
                <v-row>
                  <v-col lg="6" md="6" sm="6" cols="12">
                    <h1 style="text-align: justify; line-height: 20px; font-size: 15pt;">PRINCIPIOS</h1>
                    <ul class="mt-2">
                      <li v-for="(valor, index) in instituto.principios.split(',')" :key="index">
                        <span class="mt-2" style="font-size: small;">
                          {{ valor.trim().charAt(0).toUpperCase() + valor.trim().slice(1).toLowerCase() }}
                        </span>
                      </li>
                    </ul>
                  </v-col>
                  <v-col lg="6" md="6" sm="6" cols="12">
                    <h1 style="text-align: justify; line-height: 20px; font-size: 15pt;">VALORES</h1>
                    <ul class="mt-2">
                      <li v-for="(valor, index) in instituto.valores.split(',')" :key="index">
                        <span class="mt-2" style="font-size: small;">
                          {{ valor.trim().charAt(0).toUpperCase() + valor.trim().slice(1).toLowerCase() }}
                        </span>
                      </li>
                    </ul>
                  </v-col>
                </v-row>
              </v-container>
              <br>
            </v-card>
          </div>
        </v-container>
      </v-col>
    </v-row>
    <br>
    <v-card v-if="false" :style="{ backgroundColor: $ajustes.colorElemento }" elevation="1" :disabled="loading"
      :loading="loading">
      <h1 class="pt-5 pl-2" style="text-align: justify; line-height: 20px; font-size: 15pt;">GALERIA PRINCIPAL</h1>
      <v-row class="pt-2">
        <v-col class="ma-0 pa-2" v-for="imagen in instituto.imagenes_rutas" :key="imagen" lg="3" md="3" sm="3" cols="3"
          style="height: 100%;">
          <div class="col image">
            <img :src="imagen" alt="Instituto   ">
          </div>
        </v-col>
      </v-row>
    </v-card>
    <br>
  </div>
</template>

<script>
import ficha from "@/components/template/ficha";
import axios from 'axios';

export default {
  components: {
    ficha
  },
  metaInfo() {
    return {
      title: "Nosotros",
      titleTemplate: "%s | INSEG",
      meta: [
        {
          name: "description",
          content: "Conoce más sobre INSEG Ecuador, nuestro compromiso con la formación técnica y profesional en Seguridad Global y Transporte, INSEG Ecuador. Nuestra misión y valores."
        }
      ]
    }
  },
  data() {
    return {
      showMenu: true,
      show: {
        responsible: "",
      },
      fichas: [
      ],
      instituto: {
        mision: "",
        vision: "",
        historia: "",
      },
    };
  },
  mounted() {
    this.obtenerInstituto()
    this.obtenerInstructores()
  },
  created() {

  },
  methods: {
    async obtenerInstituto() {
      await axios.get("/obtener_instituto")
        .then((response) => {
          if (response.data) {
            this.ponerInstituto(response.data.data)
          }
        })
        .catch(() => {
          this.ponerInstitutoRecomendado(this.instituto_recomendado)
        });
      this.loading = false
    },
    async obtenerInstructores() {
      await axios.get("/obtener_instructores")
        .then((response) => {
          if (response.data) {
            this.fichas = response.data.data.filter(instructor => instructor.habilitado);
          }
        })
        .catch(() => {
          this.fichas = []
        });
      this.loading = false
    },
    ponerInstituto(aux) {
      this.instituto.mision = aux.mision
      this.instituto.vision = aux.vision
      this.instituto.historia = aux.historia
      this.instituto.principios = aux.principios
      this.instituto.valores = aux.valores
    },
    ponerInstitutoRecomendado(aux) {
      this.instituto.mision = aux.mision
      this.instituto.vision = aux.vision
      this.instituto.historia = aux.historia
    }

  },
  computed: {
  },
  beforeDestroy() {
  },
};
</script>

<style scoped>
.image {
  text-align: center;
}

.image img {
  width: 100%;
  max-width: 300px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}
</style>